<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>资产负债表（适用执行小企业会计准则的企业）</dt>

      <dd>
        <div>税款所属期间：{{ staticConfig.taxStartTime }} 至 {{ staticConfig.taxEndTime }}</div>
        <div>会小企01表 金额单位：元，至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" style="margin-bottom: 20px">
        <colgroup>
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
          <col style="width: 12%" />
        </colgroup>
        <tbody>
          <tr>
            <td colspan="2" class="th-back">纳税人名称</td>
            <td colspan="2">
              <div id="nsrmc">{{ staticConfig.companyName }}</div>
            </td>
            <td colspan="2" class="th-back">纳税人识别号</td>
            <td colspan="2">
              <div id="nsrsbh">{{ staticConfig.creditCode }}</div>
            </td>
          </tr>
        </tbody>
      </table>

      <table border="1" cellspacing="0" cellpadding="4">
        <thead>
          <tr align="center">
            <th class="title01" width="20%">资产</th>
            <th class="title01" width="6%">行次</th>
            <th class="title01" width="12%">期末余额</th>
            <th class="title01" width="12%">年初余额</th>
            <th class="title01" width="20%">负债和所有者权益</th>
            <th class="title01" width="6%">行次</th>
            <th class="title01" width="12%">期末余额</th>
            <th class="title01" width="12%">年初余额</th>
          </tr>
          <tr align="center">
            <td class="title01">流动资产：</td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01">流动负债：</td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
        </thead>
        <tbody>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">货币资金</td>
            <td class="title01" style="text-align: center">1</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v1x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">短期借款</td>
            <td class="title01" style="text-align: center">31</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v31x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v31x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v31x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v31x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v31x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v31x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v31x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v31x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">短期投资</td>
            <td class="title01" style="text-align: center">2</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v2x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">应付票据</td>
            <td class="title01" style="text-align: center">32</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v32x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v32x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v32x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v32x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v32x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v32x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v32x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v32x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">应收票据</td>
            <td class="title01" style="text-align: center">3</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v3x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v3x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">应付账款</td>
            <td class="title01" style="text-align: center">33</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v33x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v33x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v33x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v33x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v33x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v33x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v33x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v33x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">应收账款</td>
            <td class="title01" style="text-align: center">4</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v4x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v4x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">预收账款</td>
            <td class="title01" style="text-align: center">34</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v34x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v34x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v34x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v34x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v34x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v34x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v34x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v34x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">预付账款</td>
            <td class="title01" style="text-align: center">5</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v5x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v5x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">应付职工薪酬</td>
            <td class="title01" style="text-align: center">35</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v35x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v35x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v35x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v35x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v35x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v35x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v35x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v35x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">应收股利</td>
            <td class="title01" style="text-align: center">6</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v6x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v6x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">应交税费</td>
            <td class="title01" style="text-align: center">36</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v36x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v36x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v36x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v36x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v36x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v36x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v36x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v36x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">应收利息</td>
            <td class="title01" style="text-align: center">7</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v7x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v7x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">应付利息</td>
            <td class="title01" style="text-align: center">37</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v37x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v37x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v37x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v37x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v37x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v37x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v37x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v37x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">其他应收款</td>
            <td class="title01" style="text-align: center">8</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v8x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v8x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">应付利润</td>
            <td class="title01" style="text-align: center">38</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v38x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v38x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v38x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v38x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v38x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v38x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v38x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v38x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">存货</td>
            <td class="title01" style="text-align: center">9</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v9x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v9x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v9x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v9x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v9x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v9x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">其他应付款</td>
            <td class="title01" style="text-align: center">39</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v39x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v39x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v39x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v39x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v39x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v39x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v39x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v39x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 4em">其中：原材料</td>
            <td class="title01" style="text-align: center">10</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v10x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v10x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">其他流动负债</td>
            <td class="title01" style="text-align: center">40</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v40x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v40x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v40x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v40x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v40x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v40x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v40x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v40x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 4em">在产品</td>
            <td class="title01" style="text-align: center">11</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v11x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v11x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01">流动负债合计</td>
            <td class="title01" style="text-align: center">41</td>
            <td class="d3">
              {{ parseFloatNum(data.v41x1.value) }}
              <!-- <el-input-number v-model.trim="data.v41x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d4">
              {{ parseFloatNum(data.v41x2.value) }}
              <!-- <el-input-number v-model.trim="data.v41x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 4em">库存商品</td>
            <td class="title01" style="text-align: center">12</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v12x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v12x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v12x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v12x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v12x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v12x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01">非流动负债：</td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 4em">周转材料</td>
            <td class="title01" style="text-align: center">13</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v13x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v13x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v13x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v13x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">长期借款</td>
            <td class="title01" style="text-align: center">42</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v42x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v42x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v42x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v42x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v42x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v42x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v42x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v42x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">其他流动资产</td>
            <td class="title01" style="text-align: center">14</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v14x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v14x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v14x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v14x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">长期应付款</td>
            <td class="title01" style="text-align: center">43</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v43x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v43x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v43x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v43x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v43x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v43x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v43x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v43x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">流动资产合计</td>
            <td class="title01" style="text-align: center">15</td>
            <td class="d1">
              {{ parseFloatNum(data.v15x1.value) }}
              <!-- <el-input-number v-model.trim="data.v15x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d2">
              {{ parseFloatNum(data.v15x2.value) }}
              <!-- <el-input-number v-model.trim="data.v15x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="title01" style="text-indent: 2em">递延收益</td>
            <td class="title01" style="text-align: center">44</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v44x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v44x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v44x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v44x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v44x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v44x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v44x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v44x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">非流动资产：</td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01" style="text-indent: 2em">其他非流动负债</td>
            <td class="title01" style="text-align: center">45</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v45x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v45x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v45x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v45x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v45x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v45x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v45x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v45x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">长期债券投资</td>
            <td class="title01" style="text-align: center">16</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v16x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v16x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v16x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v16x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v16x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v16x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v16x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v16x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01">非流动负债合计</td>
            <td class="title01" style="text-align: center">46</td>
            <td class="d3">
              {{ parseFloatNum(data.v46x1.value) }}
              <!-- <el-input-number v-model.trim="data.v46x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d4">
              {{ parseFloatNum(data.v46x2.value) }}
              <!-- <el-input-number v-model.trim="data.v46x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">长期股权投资</td>
            <td class="title01" style="text-align: center">17</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v17x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v17x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v17x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v17x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v17x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v17x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v17x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v17x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01">负债合计</td>
            <td class="title01" style="text-align: center">47</td>
            <td class="d3">
              {{ parseFloatNum(data.v47x1.value) }}
              <!-- <el-input-number v-model.trim="data.v47x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d4">
              {{ parseFloatNum(data.v47x2.value) }}
              <!-- <el-input-number v-model.trim="data.v47x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">固定资产原价</td>
            <td class="title01" style="text-align: center">18</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v18x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v18x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v18x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v18x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">减：累计折旧</td>
            <td class="title01" style="text-align: center">19</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v19x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v19x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v19x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v19x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v19x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v19x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v19x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">固定资产账面价值</td>
            <td class="title01" style="text-align: center">20</td>
            <td class="d1">
              {{ parseFloatNum(data.v20x1.value) }}
              <!-- <el-input-number v-model.trim="data.v20x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d2">
              {{ parseFloatNum(data.v20x2.value) }}
              <!-- <el-input-number v-model.trim="data.v20x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">在建工程</td>
            <td class="title01" style="text-align: center">21</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v21x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v21x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v21x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v21x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v21x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v21x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v21x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v21x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">工程物资</td>
            <td class="title01" style="text-align: center">22</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v22x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v22x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v22x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v22x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">固定资产清理</td>
            <td class="title01" style="text-align: center">23</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v23x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v23x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v23x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v23x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v23x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v23x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v23x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">生产性生物资产</td>
            <td class="title01" style="text-align: center">24</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v24x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v24x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v24x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v24x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v24x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v24x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v24x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01">所有者权益（或股东权益）：</td>
            <td class="title01"></td>
            <td class="title01"></td>
            <td class="title01"></td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">无形资产</td>
            <td class="title01" style="text-align: center">25</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v25x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v25x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v25x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v25x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v25x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v25x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v25x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v25x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">实收资本（或股本）</td>
            <td class="title01" style="text-align: center">48</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v48x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v48x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v48x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v48x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v48x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v48x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v48x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v48x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01" style="text-indent: 2em">开发支出</td>
            <td class="title01" style="text-align: center">26</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v26x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v26x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v26x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v26x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v26x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v26x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v26x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v26x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">资本公积</td>
            <td class="title01" style="text-align: center">49</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v49x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v49x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v49x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v49x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v49x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v49x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v49x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v49x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">长期待摊费用</td>
            <td class="title01" style="text-align: center">27</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v27x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v27x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v27x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v27x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v27x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v27x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v27x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v27x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">盈余公积</td>
            <td class="title01" style="text-align: center">50</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v50x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v50x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v50x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v50x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v50x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v50x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v50x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v50x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">其他非流动资产</td>
            <td class="title01" style="text-align: center">28</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v28x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v28x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v28x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v28x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v28x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v28x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v28x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v28x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="title01" style="text-indent: 2em">未分配利润</td>
            <td class="title01" style="text-align: center">51</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v51x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v51x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v51x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v51x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v51x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v51x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v51x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v51x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">非流动资产合计</td>
            <td class="title01" style="text-align: center">29</td>
            <td class="d1">
              {{ parseFloatNum(data.v29x1.value) }}
              <!-- <el-input-number v-model.trim="data.v29x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d2">
              {{ parseFloatNum(data.v29x2.value) }}
              <!-- <el-input-number v-model.trim="data.v29x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="title01">所有者权益（或股东权益）合计</td>
            <td class="title01" style="text-align: center">52</td>
            <td class="d3">
              {{ parseFloatNum(data.v52x1.value) }}
              <!-- <el-input-number v-model.trim="data.v52x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d4">
              {{ parseFloatNum(data.v52x2.value) }}
              <!-- <el-input-number v-model.trim="data.v52x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
          <tr align="center" class="tr">
            <td class="title01">资产总计</td>
            <td class="title01" style="text-align: center">30</td>
            <td class="d1">
              {{ parseFloatNum(data.v30x1.value) }}
              <!-- <el-input-number v-model.trim="data.v30x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d2">
              {{ parseFloatNum(data.v30x2.value) }}
              <!-- <el-input-number v-model.trim="data.v30x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="title01">负债和所有者权益（或股东权益）总计</td>
            <td class="title01" style="text-align: center">53</td>
            <td class="d3">
              {{ parseFloatNum(data.v53x1.value) }}
              <!-- <el-input-number v-model.trim="data.v53x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td class="d4">
              {{ parseFloatNum(data.v53x2.value) }}
              <!-- <el-input-number v-model.trim="data.v53x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};
function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        for (let column = 1; column <= 2; column++) {
          // 15行 = 1行加到9行 再加上14行
          let res1 = new Big(0);
          for (let row = 1; row <= 14; row++) {
            if (row < 10 || row > 13) {
              res1 = res1.plus(data.value[`v${row}x${column}`].value);
            }
          }
          data.value[`v15x${column}`].value = res1.round(2).toNumber();
          // 41行 = 31行加到40行
          let res2 = new Big(0);
          for (let row = 31; row <= 40; row++) {
            res2 = res2.plus(data.value[`v${row}x${column}`].value);
          }
          data.value[`v41x${column}`].value = res2.round(2).toNumber();
          // 46行 = 42行加到45行
          let res3 = new Big(0);
          for (let row = 42; row <= 45; row++) {
            res3 = res3.plus(data.value[`v${row}x${column}`].value);
          }
          data.value[`v46x${column}`].value = res3.round(2).toNumber();
          // 47行 = 41 + 46
          data.value[`v47x${column}`].value = new Big(data.value[`v41x${column}`].value).plus(data.value[`v46x${column}`].value).round(2).toNumber();
          // 20 = 18 - 19
          data.value[`v20x${column}`].value = new Big(data.value[`v18x${column}`].value).minus(data.value[`v19x${column}`].value).round(2).toNumber();
          // 29 = 16加17加20加到28行
          let res4 = new Big(0);
          for (let row = 16; row <= 28; row++) {
            if (![18, 19].includes(row)) {
              res4 = res4.plus(data.value[`v${row}x${column}`].value);
            }
          }
          data.value[`v29x${column}`].value = res4.round(2).toNumber();
          // 30 = 15 + 29
          data.value[`v30x${column}`].value = new Big(data.value[`v15x${column}`].value).plus(data.value[`v29x${column}`].value).round(2).toNumber();
          // 52 = 48加到51
          let res5 = new Big(0);
          for (let row = 48; row <= 51; row++) {
            res5 = res5.plus(data.value[`v${row}x${column}`].value);
          }
          data.value[`v52x${column}`].value = res5.round(2).toNumber();
          // 53 = 47 + 52
          data.value[`v53x${column}`].value = new Big(data.value[`v47x${column}`].value).plus(data.value[`v52x${column}`].value).round(2).toNumber();
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4">
  <thead>
      <tr align="center">
          <th class="title01" width="20%">资产</th>
          <th class="title01" width="6%">行次</th>
          <th class="title01" width="12%">期末余额</th>
          <th class="title01" width="12%">年初余额</th>
          <th class="title01" width="20%">负债和所有者权益</th>
          <th class="title01" width="6%">行次</th>
          <th class="title01" width="12%">期末余额</th>
          <th class="title01" width="12%">年初余额</th>
      </tr>
      <tr align="center">
          <td class="title01">流动资产：</td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01">流动负债：</td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
  </thead>
  <tbody>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">货币资金</td>
          <td class="title01" style="text-align:center">1</td>
          <td class="d1">
              <input type="text" style="width: 100%" value="0" class="input2 i1" daan="221177.32">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%; text-align: right;" value="0" class="input2 i1" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">短期借款</td>
          <td class="title01" style="text-align:center">31</td>
          <td class="d3">
              <input type="text" style="width: 100%" value="0" class="input2 i31 " daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" value="0" class="input2 i31 " daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">短期投资</td>
          <td class="title01" style="text-align:center">2</td>
          <td class="d1">
              <input type="text" style="width: 100%" value="0" class="input2 i2 " daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" value="0" class="input2 i2 " daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">应付票据</td>
          <td class="title01" style="text-align:center">32</td>
          <td class="d3">
              <input type="text" style="width: 100%" value="0" class="input2 i32 " daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" value="0" class="input2 i32 " daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">应收票据</td>
          <td class="title01" style="text-align:center">3</td>
          <td class="d1">
              <input type="text" style="width: 100%" value="0" class="input2 i3" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" value="0" class="input2 i3" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">应付账款</td>
          <td class="title01" style="text-align:center">33</td>
          <td class="d3">
              <input type="text" style="width: 100%" value="0" class="input2 i33" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" value="0" class="input2 i33" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">应收账款</td>
          <td class="title01" style="text-align:center">4</td>
          <td class="d1">
              <input type="text" style="width: 100%" value="0" class="input2 i4" daan="11850.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" value="0" class="input2 i4" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">预收账款</td>
          <td class="title01" style="text-align:center">34</td>
          <td class="d3">
              <input type="text" style="width: 100%" value="0" class="input2 i34" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" value="0" class="input2 i34" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">预付账款</td>
          <td class="title01" style="text-align:center">5</td>
          <td class="d1">
              <input type="text" style="width: 100%" value="0" class="input2 i5" daan="3000.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" value="0" class="input2 i5" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">应付职工薪酬</td>
          <td class="title01" style="text-align:center">35</td>
          <td class="d3">
              <input type="text" style="width: 100%" value="0" class="input2 i35" daan="17000.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" value="0" class="input2 i35" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">应收股利</td>
          <td class="title01" style="text-align:center">6</td>
          <td class="d1">
              <input type="text" style="width: 100%" value="0" class="input2 i6" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i6" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">应交税费</td>
          <td class="title01" style="text-align:center">36</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i36" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i36" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">应收利息</td>
          <td class="title01" style="text-align:center">7</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i7" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i7" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">应付利息</td>
          <td class="title01" style="text-align:center">37</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i37" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i37" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">其他应收款</td>
          <td class="title01" style="text-align:center">8</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i8" value="0" daan="3000.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i8" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">应付利润</td>
          <td class="title01" style="text-align:center">38</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i38" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i38" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">存货</td>
          <td class="title01" style="text-align:center">9</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i9" value="0" daan="11300.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i9" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">其他应付款</td>
          <td class="title01" style="text-align:center">39</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i39" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i39" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:4em;">其中：原材料</td>
          <td class="title01" style="text-align:center">10</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i10" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i10" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">其他流动负债</td>
          <td class="title01" style="text-align:center">40</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i40" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i40" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:4em;">在产品</td>
          <td class="title01" style="text-align: center;">11</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i11" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i11" value="0" daan="0.00">
          </td>
          <td class="title01">流动负债合计</td>
          <td class="title01" style="text-align:center">41</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i41" value="0" daan="17000.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i41" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:4em;">库存商品</td>
          <td class="title01" style="text-align:center">12</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i12" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i12" value="0" daan="0.00">
          </td>
          <td class="title01">非流动负债：</td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:4em;">周转材料</td>
          <td class="title01" style="text-align:center">13</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i13" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i13" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">长期借款</td>
          <td class="title01" style="text-align:center">42</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i42" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i42" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">其他流动资产</td>
          <td class="title01" style="text-align:center">14</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i14" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i14" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">长期应付款</td>
          <td class="title01" style="text-align:center">43</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i43" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i43" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">流动资产合计</td>
          <td class="title01" style="text-align:center">15</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i15" value="0" daan="250327.32">
          </td>
          <td class="d2"><input type="text" style="width: 100%" class="input2 i15" value="0" daan="0.00"></td>
          <td class="title01" style="text-indent:2em;">递延收益</td>
          <td class="title01" style="text-align:center">44</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i44" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i44" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">非流动资产：</td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01" style="text-indent:2em;">其他非流动负债</td>
          <td class="title01" style="text-align:center">45</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i45" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i45" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">长期债券投资</td>
          <td class="title01" style="text-align:center">16</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i16" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i16" value="0" daan="0.00">
          </td>
          <td class="title01">非流动负债合计</td>
          <td class="title01" style="text-align:center">46</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i46" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i46" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">长期股权投资</td>
          <td class="title01" style="text-align:center">17</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i17" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i17" value="0" daan="0.00">
          </td>
          <td class="title01">负债合计</td>
          <td class="title01" style="text-align:center">47</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i47" value="0" daan="17000.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i47" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">固定资产原价</td>
          <td class="title01" style="text-align:center">18</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i18" value="0" daan="6900.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i18" value="0" daan="0.00">
          </td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">减：累计折旧</td>
          <td class="title01" style="text-align:center">19</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i19" value="0" daan="109.25">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i19" value="0" daan="0.00">
          </td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">固定资产账面价值</td>
          <td class="title01" style="text-align:center">20</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i20" value="0" daan="6790.75">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i20" value="0" daan="0.00">
          </td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">在建工程</td>
          <td class="title01" style="text-align:center">21</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i21" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i21" value="0" daan="0.00">
          </td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">工程物资</td>
          <td class="title01" style="text-align:center">22</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i22" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i22" value="0" daan="0.00">
          </td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">固定资产清理</td>
          <td class="title01" style="text-align:center">23</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i23" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i23" value="0" daan="0.00">
          </td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">生产性生物资产 </td>
          <td class="title01" style="text-align:center">24</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i24" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i24" value="0" daan="0.00">
          </td>
          <td class="title01">所有者权益（或股东权益）：</td>
          <td class="title01"></td>
          <td class="title01"></td>
          <td class="title01"></td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">无形资产</td>
          <td class="title01" style="text-align:center">25</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i25" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i25" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">实收资本（或股本）</td>
          <td class="title01" style="text-align:center">48</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i48" value="0" daan="250000.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i48" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01" style="text-indent:2em;">开发支出 </td>
          <td class="title01" style="text-align:center">26</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i26" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i26" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">资本公积</td>
          <td class="title01" style="text-align:center">49</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i49" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i49" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">长期待摊费用 </td>
          <td class="title01" style="text-align:center">27</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i27" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i27" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">盈余公积</td>
          <td class="title01" style="text-align:center">50</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i50" value="0" daan="0.00">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i50" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">其他非流动资产</td>
          <td class="title01" style="text-align:center">28</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i28" value="0" daan="0.00">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i28" value="0" daan="0.00">
          </td>
          <td class="title01" style="text-indent:2em;">未分配利润</td>
          <td class="title01" style="text-align:center">51</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i51" value="0" daan="-9881.93">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i51" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">非流动资产合计</td>
          <td class="title01" style="text-align:center">29</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i29" value="0" daan="6790.75">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i29" value="0" daan="0.00">
          </td>
          <td class="title01">所有者权益（或股东权益）合计</td>
          <td class="title01" style="text-align:center">52</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i52" value="0" daan="240118.07">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i52" value="0" daan="0.00">
          </td>
      </tr>
      <tr align="center" class="tr">
          <td class="title01">资产总计</td>
          <td class="title01" style="text-align:center">30</td>
          <td class="d1">
              <input type="text" style="width: 100%" class="input2 i30" value="0" daan="257118.07">
          </td>
          <td class="d2">
              <input type="text" style="width: 100%" class="input2 i30" value="0" daan="0.00">
          </td>
          <td class="title01">负债和所有者权益（或股东权益）总计</td>
          <td class="title01" style="text-align:center">53</td>
          <td class="d3">
              <input type="text" style="width: 100%" class="input2 i53" value="0" daan="257118.07">
          </td>
          <td class="d4">
              <input type="text" style="width: 100%" class="input2 i53" value="0" daan="0.00">
          </td>
      </tr>

  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
